import showToast from '@Common/toast/showToast';
import { useGeneratorContext } from '@Context/GeneratorContext';
import { AhaTicketGeneratorPrompt } from '@Models/types';
import { PaperPlaneRight } from '@phosphor-icons/react';
import { useState } from 'react';

interface Props {
  basePrompt: AhaTicketGeneratorPrompt | null;
}
const Prompt: React.FC<Props> = ({ basePrompt }) => {
  const [prompt, setPrompt] = useState('');
  const { generateAhaTicket, generateAhaLoading, setPublishedAhaLink } =
    useGeneratorContext();

  const handleSubmit = async (e: React.FormEvent) => {
    setPublishedAhaLink(null);
    e.preventDefault();
    if (!basePrompt) {
      showToast.error('Please select a base prompt first');
      return;
    }
    const appendedPrompt = basePrompt?.prompt + prompt;
    const cleanedPrompt = appendedPrompt.replace(/"/g, '');
    if (!prompt.trim()) return;
    await generateAhaTicket(cleanedPrompt);
  };

  return (
    <div className="flex h-full flex-col rounded-lg bg-white p-4">
      <span className="mb-2 font-extrabold text-primary-700">Prompt</span>

      <form
        onSubmit={handleSubmit}
        className="flex h-full flex-1 flex-col gap-2 rounded-lg border border-gray-300 bg-white p-3 shadow-sm focus-within:ring-2 focus-within:ring-primary-500"
      >
        <div className="flex h-full flex-1 items-start gap-2">
          <textarea
            className="h-full w-full flex-1 resize-none border-0 p-2 text-sm text-gray-700 placeholder:text-gray-400 focus:outline-none focus:ring-0"
            placeholder="Create a detailed prompt/user story..."
            value={prompt}
            onChange={(e) => setPrompt(e.target.value)}
            readOnly={generateAhaLoading}
          />

          <button
            type="submit"
            className="hover:text-primary-900 mt-2 text-primary-700 disabled:text-gray-300"
            disabled={!prompt.trim() || generateAhaLoading}
            title="Send Prompt"
          >
            <PaperPlaneRight size={24} weight="bold" />
          </button>
        </div>
      </form>
    </div>
  );
};

export default Prompt;
